// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import StaffHomePage from './pages/StaffHomePage';
import StaffFormPage from './pages/StaffFormPage';
import CustomerFormPage from './pages/CustomerFormPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { RequireAuth, PublicOnly } from './components/auth/AuthGuard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing: Choose Customer or Staff */}
        <Route path="/" element={
          <PublicOnly>
            <LandingPage />
          </PublicOnly>
        } />

        {/* Customer support form */}
        <Route path="/customer" element={<CustomerFormPage />} />

        {/* Staff internal help center */}
        <Route path="/staff" element={
          <PublicOnly>
            <LoginPage />
          </PublicOnly>
        } />

        {/* Staff signup page */}
        <Route path="/signup" element={
          <PublicOnly>
            <SignupPage />
          </PublicOnly>
        } />

        {/* Forgot password flow */}
        <Route path="/forgot-password" element={
          <PublicOnly>
            <ForgotPasswordPage />
          </PublicOnly>
        } />

        <Route path="/reset-password" element={
          <PublicOnly>
            <ResetPasswordPage />
          </PublicOnly>
        } />

        <Route path="/staff/dashboard" element={
          <RequireAuth>
            <StaffHomePage />
          </RequireAuth>
        } />

        <Route path="/staff/request/:formId/:subFormId?" element={
          <RequireAuth>
            <StaffFormPage />
          </RequireAuth>
        } />
      </Routes>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
    </BrowserRouter>
  );
}
